import { useFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks';
import { useCallback } from 'react';

import type { IApiError } from '../services/apiError';

/** The text of a failed save or action. */
export function useErrorText(): (error: IApiError) => string {
  const { t } = useFormatMessage();
  return useCallback(
    (error: IApiError) => {
      if (error.kind === 'network') {
        return t({
          id: 'shell.error.network',
          defaultMessage: 'Не удалось связаться с сервисом анонсов. Проверьте подключение к сети и повторите попытку.',
          description: 'Ошибка сети при загрузке или сохранении',
        });
      }
      if (error.kind === 'invalid') {
        return t(
          {
            id: 'announcements.validation.server',
            defaultMessage: 'Сервис отклонил анонс: {message}',
            description: 'Сервис отклонил анонс; message — текст ответа сервиса',
          },
          { message: error.message },
        );
      }
      if (error.kind === 'denied') {
        return t({
          id: 'shell.noAccess.title',
          defaultMessage: 'Нет доступа',
          description: 'Заголовок экрана и ошибка при отказе в доступе',
        });
      }
      return t(
        {
          id: 'shell.error.generic',
          defaultMessage: 'Не удалось выполнить запрос: {message}',
          description: 'Ошибка запроса; message — текст ошибки',
        },
        { message: error.message },
      );
    },
    [t],
  );
}
